import { render } from "./IntegrationsComingSoon.vue?vue&type=template&id=4ee081d4&scoped=true"
import script from "./IntegrationsComingSoon.vue?vue&type=script&lang=ts"
export * from "./IntegrationsComingSoon.vue?vue&type=script&lang=ts"

import "./IntegrationsComingSoon.vue?vue&type=style&index=0&id=4ee081d4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4ee081d4"

export default script